// eslint-disable-next-line no-unused-vars
const VERSION_OPTIONS = [
  { label: 'Adviser', value: 'adviser', show: true },
  { label: 'Investors', value: 'investor', show: false },
];

export default VERSION_OPTIONS;
